export const NETWORKS = {
    MAINNET: { networkId: '1', name: 'Mainnet' },
    ROPSTEN: { networkId: '42', name: 'Kovan' },
}

export const WALLET_CONNECT = 'walletconnect';
